import { useRef } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';

import { ButtonV2 } from '../../../components/common/v2/ButtonV2/ButtonV2';
import { SelectMenuV2 } from '../../../components/common/v2/SelectMenuV2/SelectMenuV2';
import { PRIMARY_SILVER_COLOR } from '../../../themes/light';

const options = [
  {
    label: 'Single Location',
    value: 'add-single-location',
  },
  {
    label: 'Multiple Locations',
    value: 'add-multiple-locations',
  },
];

export const AddLocationsSelectV2 = ({ selectedVariant, setSelectedVariant }) => {
  const wrapperRef = useRef(null);

  return (
    <Wrapper ref={wrapperRef}>
      <SelectMenuV2
        ref={wrapperRef}
        options={options}
        menuLabel="Region"
        selected={selectedVariant}
        onChange={setSelectedVariant}
        popoverPositionX="right"
        customHead={
          <ButtonV2 variant="contained" startIcon={<AddIcon />} sx={{ fontFamily: 'Calibre-R' }}>
            Add Location
          </ButtonV2>
        }
      />
    </Wrapper>
  );
};

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  '&:hover': {
    background: PRIMARY_SILVER_COLOR[100],
  },
}));
